"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var filters_1 = require("../../../helpers/filters");
var react_redux_1 = require("react-redux");
var languageSlice_1 = require("../../../features/languages/languageSlice");
var SelectedValues = function (_a) {
    var selected = _a.selected, states = _a.states;
    var currentLanguage = react_redux_1.useSelector(languageSlice_1.selectCurrentLanguage);
    return selected.length ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { className: "choosen-val" }, filters_1.getStateNameById(selected[0], states, currentLanguage)),
        selected.length > 1 && (react_1.default.createElement("span", { className: "selected-count" },
            "+",
            selected.length - 1)))) : (react_1.default.createElement(react_1.default.Fragment, null));
};
exports.default = react_1.memo(SelectedValues);
